"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNegative = exports.isPositive = exports.isArrayWithData = exports.isEmpty = exports.isObject = exports.isNil = exports.isPromise = exports.isArray = exports.isNumber = exports.isString = exports.isNull = exports.isUndefined = void 0;
var isUndefined = function (target) {
    return target === undefined;
};
exports.isUndefined = isUndefined;
var isNull = function (target) { return target === null; };
exports.isNull = isNull;
var isString = function (target) {
    return typeof target === 'string';
};
exports.isString = isString;
var isNumber = function (target) {
    return typeof target === 'number' && !isNaN(target);
};
exports.isNumber = isNumber;
var isArray = function (target) {
    return Array.isArray(target);
};
exports.isArray = isArray;
var isPromise = function (target) {
    return !!target && typeof target.then === 'function';
};
exports.isPromise = isPromise;
var isNil = function (target) {
    return (0, exports.isNull)(target) || (0, exports.isUndefined)(target);
};
exports.isNil = isNil;
var isObject = function (target) {
    return typeof target === 'object';
};
exports.isObject = isObject;
var isEmpty = function (target) {
    if ((0, exports.isNull)(target) || (0, exports.isUndefined)(target)) {
        return true;
    }
    if ((0, exports.isString)(target)) {
        return target.length === 0;
    }
    if ((0, exports.isNumber)(target)) {
        return target === 0;
    }
    if ((0, exports.isObject)(target)) {
        return Object.keys(target).length === 0;
    }
    if ((0, exports.isArray)(target)) {
        return target.length === 0;
    }
    return false;
};
exports.isEmpty = isEmpty;
var isArrayWithData = function (target) {
    return (0, exports.isArray)(target) && target.length > 0;
};
exports.isArrayWithData = isArrayWithData;
var isPositive = function (target) {
    return target > 0;
};
exports.isPositive = isPositive;
var isNegative = function (target) {
    return target < 0;
};
exports.isNegative = isNegative;
